import { render, staticRenderFns } from "./firstStep.vue?vue&type=template&id=c5b47fb8&"
import script from "./firstStep.vue?vue&type=script&lang=js&"
export * from "./firstStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports